import { find } from 'lodash';

const getStatus = (statuses, status) => find(statuses, ({ label, key }) => key === status || label === status) || {};

export { getStatus };
